import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import MenuTable from "../../helpers/MenuTable";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import AppContext from "../../AppContext";
import InputDate from "../../helpers/InputDate";
import InputColor from "../../helpers/InputColor";
import InputSearchEmp from "../../helpers/InputSearchEmp";


export default function WeekPlan(props) {


        const tabRef = useRef(0);
        const tab2Ref = useRef(0);

        const [filterParam, setFilterParam] = useState({  

            men_dziennik_id: props.id,
            dzien: props.mainView.readFilter('dzien',''),           
        
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            limit: 50,
            page: 1,
            pages: 1,
            show: true,
        });
        const [tab, setTab] = useState(null);


       const [errTab, setErrTab] = useState([]);  //z info od serwera..

        const [detailsItem, setDetailsItem] = useState(null);
        const [selectedItem, setSelectedItem] = useState({
            id: -1,
            day: "",
            hhmm: "",
        });


   const valChangeListenerRow = (filedName, val, correct, msg) => {

        console.log("valChangeListenerRow: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
 
        setDetailsItem( {...detailsItem, [filedName]:val,  [filedName+"_valid"]:correct } );   
      
    }  




        
      const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }

        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }

            
      const filterClear = () => {
 
            props.mainView.writeFilter('dzien', '');    
            setFilterParam({
 
                men_dziennik_id: props.id,
                dzien: '',
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


        const filterApprove = () => {   
            setTab(null)     
        }


    const getTab = () => {
       
    
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_men,week_plan', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);             

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

     return false;
}

  const getItemDetails= () => {
       
    
        props.mainView.setProgress(-2);
    
        var req = {
            id: selectedItem.id,
            dzien: selectedItem.day,
            hhmm: selectedItem.hhmm,
        };


        fetch( Config.url + '/rest_v1_men,week_details_day', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setDetailsItem(res.result);           
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

     return false;
}

  const saveData= () => {
       
    


    if(detailsItem.tytul.length < 3) {

        props.mainView.showDialog( "Error", "Podaj tytuł" , "ok" , null);  
        return;
    }

    if(detailsItem.opis.length < 3) {

        props.mainView.showDialog( "Error", "Podaj opis" , "ok" , null);  
        return;
    }

    
    if(detailsItem.nauczyciel_px_group_id.length < 2 || detailsItem.nauczyciel_px_group_id == -1) {

        props.mainView.showDialog( "Error", "Wybierz nauczyciela prowadzącego" , "ok" , null);  
        return;
    }


    console.log(detailsItem);
    if(detailsItem.nauczyciel_px_group_id != '-1')
    {
        var spx = detailsItem.nauczyciel_px_group_id.split(" | ");
        detailsItem.nauczyciel_px_group_id = spx[0];
    }


    var tmpCheck = parseInt(detailsItem.nauczyciel_px_group_id);

    if(tmpCheck == NaN || tmpCheck == "NaN" || isNaN(tmpCheck))
    {
        props.mainView.showDialog( "Error", "Wybierz nauczyciela prowadzącego" , "ok" , null);  
        return;
    }




        props.mainView.setProgress(-2);
    
        detailsItem.men_dziennik_id = props.id; 

        fetch( Config.url + '/rest_v1_men,week_detail_set', {
            method: 'POST', 
            body: JSON.stringify(detailsItem), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        onClickClose();
                        getTab();
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

     return false;
}

  const goRemove= () => {
       
   

        props.mainView.setProgress(-2);
    
        detailsItem.men_dziennik_id = props.id; 

        fetch( Config.url + '/rest_v1_men,week_detail_remove', {
            method: 'POST', 
            body: JSON.stringify(detailsItem), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        onClickClose();
                        getTab();
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

     return false;
}


    const onClickItem = (e) => {

        //   atr-id={wpis.id} atr-day={dd.day} atr-hour={hhmm.hhmm}

        if(props.status != "aktywny" )
        {
            return;
        }



        var id = e.target.getAttribute('atr-id');
        var idC = e.currentTarget.getAttribute('atr-id');

        if(id != idC) return;  //drugi klik od elemtu wyżej..

        var day = e.target.getAttribute('atr-day');
        var hhmm = e.target.getAttribute('atr-hour');

       // alert(id + " | " + idC  +" " + day +" " +  hhmm);


        setDetailsItem(null); //niech pobierze ponownie..

        setSelectedItem({
            id: id,
            day: day,
            hhmm: hhmm,
        });

    }

    const onClickClose = () => {
       
        setSelectedItem({
            id: -1,
            day: "",
            hhmm: "",
        }); 
    }




   if(tab == null)
   {
      setTab([]);
      getTab();    
      return <div>...</div>
   }

   if(tab.dni == undefined ||  tab.dni.length < 1)
   {
       return <div>...</div>
   }



   
   var viewDialog = null;

   if(selectedItem.day.length > 0 && detailsItem == null)
   {
        setDetailsItem([]);
        getItemDetails();        
   }

   if(selectedItem.day.length > 0 && detailsItem != null && detailsItem.dzien != undefined && detailsItem.dzien.length > 0)
   {
        viewDialog = <div className="dlg_window dlg_type_xx shadowx">

                    
                    <div className="dlg_title">
                        Nowy wpis {detailsItem.dzien} / {detailsItem.godzina}
                    </div>

                    <div className="dlg_content_x scroll500">


                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Tytuł</div>
                                                <InputText   userData={props.userData} value={detailsItem.tytul} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="tytul" placeholder={"Temat: "} className=' w300 ' req='1' firstUp="1" />
                                            </div>
                                      

                                            <div className="form_control">
                                                <div className="fieldName">Kolor zaznaczenia</div>
                                                <InputColor   userData={props.userData} value={detailsItem.kolor} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="kolor" placeholder={"Temat: "} className=' w50 ' req='0' firstUp="1" />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control p100">
                                                            <div className="fieldName">Opis, szczegóły</div>
                                                            <InputTextArea   value={detailsItem.opis} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="opis" placeholder={""} className=' p100 h100 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control p100">
                                                            <div className="fieldName">Nauczyciel, osoba prowadząca zajęcia</div>
                                                            <InputSearchEmp userData={props.userData} mainView={props.mainView}   value={detailsItem.nauczyciel_px_group_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="nauczyciel_px_group_id" placeholder={""} className=' w200  ' req='1' firstUp="1" />
                                            </div>
                            </div>

                             
                                            <div className="form_split"></div>

                                            <div className="form_control">                         
                                                {
                                                    detailsItem.id > 0 &&
                                                    <Fragment>
                                                        &nbsp;
                                                             <div className="btn btn_red" onClick={goRemove}>usuń</div>
                                                        &nbsp; &nbsp; &nbsp;
                                                    </Fragment>
                                                }                   
                                                <div className="btn" onClick={saveData}>dodaj</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={onClickClose}>anuluj</div>
                                            </div>

                    </div>
        </div>
   }


 

       return (
        <div className="view_content">
            
 

            <div className="bg_center">

                       <div className="table_filter">


                            <div className="filter_controll">   
                                    <label>Dzień: </label>                             
                                    <InputDate   userData={props.userData}  mainView={props.mainView}   value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={": "}  noempty="0"   />
                            </div>

                            
                            <div className="filter_btn">                           
                                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                       </div>


                        <div className="table_widget">                                                    
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="portrait" title={props.title  } />    
                        </div>



                        <div ref={tabRef} className="gohide">
                            <h3>{props.title} / Plan tygodniowy</h3>  
                            <br/>&nbsp;<br/>

                                    <table  className="table" >
                                            <thead>
                                                <tr className="header">       
                                                    <td className="td_left">&nbsp;</td>
                                                    {
                                                        tab.dni.map( (item,ix) => {

                                                            var css = "";
                                                            if(item.w == 0 ) css = "td_right";

                                                            if(item.w == 0 || item.w == 6) return null;

                                                            return <td className={css}>
                                                                        <div>{item.day}</div>
                                                                        {
                                                                            item.w == 0 &&
                                                                            <div>Niedziela</div>
                                                                        }
                                                                        {
                                                                            item.w == 1 &&
                                                                            <div>Poniedziałek</div>
                                                                        }
                                                                        {
                                                                            item.w == 2 &&
                                                                            <div>Wtorek</div>
                                                                        }
                                                                        {
                                                                            item.w == 3 &&
                                                                            <div>Środa</div>
                                                                        }
                                                                        {
                                                                            item.w == 4 &&
                                                                            <div>Czwartek</div>
                                                                        }
                                                                        {
                                                                            item.w == 5 &&
                                                                            <div>Piątek</div>
                                                                        }
                                                                        {
                                                                            item.w == 6 &&
                                                                            <div>Sobota</div>
                                                                        }
                                                            </td>
                                                        } )
                                                    }
                                                </tr>
                                            </thead>

                                            <tbody>

                                                        {
                                                                tab.dni[0].hhmm.map( (hhmm,ix) => {

                                                                        return <tr className="goTop">

                                                                                <td className="gocenter h100">{hhmm.hhmm}</td>
                                                                                {
                                                                                    tab.dni.map((dd, dInx) => {

                                                                                        var wpisy = null;

                                                                                       if(dd.w == 0 || dd.w == 6) return null;

                                                                                        for(var kk=0; kk < dd.hhmm.length; kk++)
                                                                                        {
                                                                                            if(dd.hhmm[kk].hhmm == hhmm.hhmm)
                                                                                            {
                                                                                                wpisy = dd.hhmm[kk].wpisy;
                                                                                                //console.log("wpisy" + wpisy.hhmm + " " + dd.day);
                                                                                            }
                                                                                        }

                                                                                        return <td className="goTop" atr-id={-1} atr-day={dd.day} atr-hour={hhmm.hhmm} onClick={onClickItem} style={{height: '100px', width:'18%'}} >    
                                                                                                        {
                                                                                                            wpisy != null &&
                                                                                                            <div>
                                                                                                                    {
                                                                                                                        wpisy.map( (wpis, inxWpis)  => {

                                                                                                                         

                                                                                                                            return <div  atr-id={wpis.id} atr-day={dd.day} atr-hour={hhmm.hhmm} onClick={onClickItem} >
                                                                                                                                {wpis.godzina},<br/>
                                                                                                                                {wpis.nauczyciel.imie} {wpis.nauczyciel.nazwisko}
                                                                                                                                 <br/>
                                                                                                                                {wpis.tytul} <br/>
                                                                                                                                {wpis.opis}
                                                                                                                            </div>

                                                                                                                        })
                                                                                                                    }
                                                                                                            </div>
                                                                                                        }
                                                                                            
                                                                                            </td>

                                                                                    })                                                                    

                                                                                }
                                                                        </tr>

                                                                })
                                                        }


                                            </tbody>
                                        

                                    </table>

                        </div>


                           <table  className="table" >
                            <thead>
                                <tr className="header">       
                                    <td className="td_left">&nbsp;</td>
                                    {
                                        tab.dni.map( (item,ix) => {

                                            var css = "";
                                            if(item.w == 0 ) css = "td_right";

                                            return <td className={css}>
                                                        <div>{item.day}</div>
                                                        {
                                                            item.w == 0 &&
                                                            <div>Niedziela</div>
                                                        }
                                                        {
                                                            item.w == 1 &&
                                                            <div>Poniedziałek</div>
                                                        }
                                                        {
                                                            item.w == 2 &&
                                                            <div>Wtorek</div>
                                                        }
                                                        {
                                                            item.w == 3 &&
                                                            <div>Środa</div>
                                                        }
                                                        {
                                                            item.w == 4 &&
                                                            <div>Czwartek</div>
                                                        }
                                                        {
                                                            item.w == 5 &&
                                                            <div>Piątek</div>
                                                        }
                                                        {
                                                            item.w == 6 &&
                                                            <div>Sobota</div>
                                                        }
                                            </td>
                                        } )
                                    }
                                </tr>
                            </thead>

                            <tbody>

                                        {
                                                   tab.dni[0].hhmm.map( (hhmm,ix) => {

                                                        return <tr className="goTop">

                                                                <td className="gocenter h100">{hhmm.hhmm}</td>
                                                                {
                                                                    tab.dni.map((dd, dInx) => {

                                                                        var wpisy = null;

                                                                        for(var kk=0; kk < dd.hhmm.length; kk++)
                                                                        {
                                                                            if(dd.hhmm[kk].hhmm == hhmm.hhmm)
                                                                            {
                                                                                wpisy = dd.hhmm[kk].wpisy;
                                                                                //console.log("wpisy" + wpisy.hhmm + " " + dd.day);
                                                                            }
                                                                        }

                                                                        return <td className="goTop" atr-id={-1} atr-day={dd.day} atr-hour={hhmm.hhmm} onClick={onClickItem} >                                                                                 
                                                                                        {
                                                                                            wpisy != null &&
                                                                                            <div>
                                                                                                    {
                                                                                                        wpisy.map( (wpis, inxWpis)  => {

                                                                                                            var tytul = wpis.tytul.substring(0,15) + "...";

                                                                                                            return <div className="menu_book_day_item" style={{backgroundColor: wpis.kolor}} atr-id={wpis.id} atr-day={dd.day} atr-hour={hhmm.hhmm} onClick={onClickItem} >
                                                                                                                  {tytul}
                                                                                                            </div>

                                                                                                        })
                                                                                                    }
                                                                                            </div>
                                                                                        }
                                                                               
                                                                            </td>

                                                                    })                                                                    

                                                                }
                                                        </tr>

                                                   })
                                        }


                            </tbody>
                          

                       </table>
            </div>
            {viewDialog}
        </div>
       )
}